// extracted by mini-css-extract-plugin
export default {"heading":"UI","container":"VI","product_section_row":"WI","carousel":"XI","carouselwide":"YI","carouselwrapper":"ZI","blockwrapper":"aJ","product_carousel_row":"bJ","headingnarrow":"cJ","title":"eJ"};
    if(module.hot) {
      // 1713211521449
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  